/**
 * AdminSectionCard — Uniforme kaart-container voor admin panelen.
 *
 * Wraps content with a consistent white surface, rounded-2xl corners,
 * subtle shadow and consistent padding. Vervangt de losse
 * `bg-white border border-slate-200 rounded-md` combinaties overal.
 *
 * Voorbeeld:
 *   <AdminSectionCard title="Werkvoorraad" actions={<Button />}>
 *     <table>...</table>
 *   </AdminSectionCard>
 */
import React from "react";

export default function AdminSectionCard({
  title,
  subtitle,
  actions,
  padded = true,
  children,
  className = "",
  testid,
}) {
  return (
    <section
      className={`bg-white border border-slate-200 rounded-2xl shadow-brand-soft overflow-hidden ${className}`}
      data-testid={testid}
    >
      {(title || actions) ? (
        <header className="flex items-center justify-between gap-3 flex-wrap px-5 py-3.5 border-b border-slate-200 bg-gradient-to-b from-white to-slate-50/60">
          <div className="min-w-0">
            {title ? (
              <h2 className="font-chivo font-bold text-brand-900 text-base leading-tight">{title}</h2>
            ) : null}
            {subtitle ? (
              <p className="text-xs text-ink-500 mt-0.5">{subtitle}</p>
            ) : null}
          </div>
          {actions ? <div className="flex items-center gap-2 flex-wrap">{actions}</div> : null}
        </header>
      ) : null}
      <div className={padded ? "p-4 sm:p-5" : ""}>{children}</div>
    </section>
  );
}
